export enum NotificationEvents {
  BOOKING_OFFER_CHANGE = 'BOOKING_OFFER_CHANGE',
}
